<template>
  <div id="main" :class="layout">

    <transition name="fade">
      <Loading v-if="loading" />
    </transition>

    <ModalGeneric />
    <MensagemAlerta />

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store";
import Loading from "@/components/loading/Loading.vue";
import { listIntegrations } from "@/api/integrations";
const MensagemAlerta = () => import("@/components/modal/MensagemAlerta.vue");
const ModalGeneric = () => import("@/components/modal/Modal.vue");

export default {
  components: {
    Loading,
    MensagemAlerta,
    ModalGeneric,
  },
  data() {
    return {
      genericModalLoadedOnce: false
    }
  },
  methods: {
    listIntegrations,
    loadData() {
      if (store.state.user.estaLogado) {
        // console.log('ESTÁ LOGADO');
        this.listIntegrations();
      }
    },
  },
  computed: {
    ...mapState({
      integrations: state => state.integrations.integrations,
    }),
    logado() {
      return this.$store.state.user.estaLogado;
    },
    layout() {
      return this.$store.state.interacoes.layout;
    },
    loading() {
      return this.$store.state.interacoes.loading;
    },
    modal() {
      return this.$store.state.interacoes.modal;
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    logado(data) {
      if (data == true) {
        this.loadData();
      }
    },
    integrations(data) {
      if (data !== null && data.length == 0 && this.genericModalLoadedOnce == false) {
        // console.log('ZERO INTEGRATIONS --> SHOW ALERT MODAL');

        const integrationsPage = (window.location.href.includes('settings/integrations'));
        store.commit("interacoes/SET_GENERIC_MODAL", {
          ativado: true,
          content: {
            title: (integrationsPage) ? "🚀 Vamos conectar sua fonte de dados" : "🚀 Conecte sua fonte de dados!",
            subtitle: "Conecte uma fonte de dados e acompanhe os seus resultados.",
            text: "Configurar sua integração é o primeiro passo para transformar seus dados em decisões estratégicas. Monitore seus pedidos com precisão, reduza o trabalho manual e foque no que realmente importa: fazer seu negócio crescer.",
            button: {
              text: (integrationsPage) ? "Ok" : "Integrar Agora",
              link: (integrationsPage) ? "close" : "/settings/integrations",
            }
          }
        });

        // Set to not load anymore
        this.genericModalLoadedOnce = true;
      }
    }
  },
};
</script>
